import React from "react";
import clsx from "clsx";
import {
  DialogTrigger,
  Modal as RACModal,
  Dialog,
  ModalOverlay,
  DialogRenderProps,
} from "react-aria-components";

import Button, { ButtonProps } from "../forms/button";

import styles from "./modal.module.css";

interface ModalProps {
  trigger: ButtonProps;
  children:
    | ((dialogRenderProps: DialogRenderProps) => React.ReactNode)
    | React.ReactNode;
  header?:
    | ((dialogRenderProps: DialogRenderProps) => React.ReactNode)
    | React.ReactNode;
  footer?:
    | ((dialogRenderProps: DialogRenderProps) => React.ReactNode)
    | React.ReactNode;
}

function Modal({ trigger, children, header, footer }: ModalProps) {
  return (
    <DialogTrigger>
      <Button {...trigger} />
      <ModalOverlay
        isDismissable={true}
        className={styles.modalOverlay}
        shouldCloseOnInteractOutside={() => {
          return true;
        }}
      >
        <RACModal
          className={({ isEntering }) =>
            clsx(styles.modal, { [styles.loading]: isEntering })
          }
        >
          <Dialog className={styles.dialog}>
            {(actions) => (
              <div>
                <div className={styles.header}>
                  <div>
                    {typeof header === "function" ? header(actions) : header}
                  </div>
                  <Button
                    className={styles.dismissButton}
                    aria-label="Close"
                    slot="close"
                    variant="tertiary"
                    icon={{ type: "x" }}
                  />
                </div>
                {typeof children === "function" ? children(actions) : children}
                <div className={styles.footer}>
                  {typeof footer === "function" ? footer(actions) : footer}
                </div>
              </div>
            )}
          </Dialog>
        </RACModal>
      </ModalOverlay>
    </DialogTrigger>
  );
}

export default Modal;
